export default function downloadFileByLink(url: string, title: string) {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.setAttribute('download', `${title}.pdf`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
